module.exports = __webpack_public_path__ + "static/media/the-dutch_gin-tonic.3c1c40bc.jpg";